module.exports = __webpack_public_path__ + "img/descripcion.0abd2e6d.png";